import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  openModal(e) {
    e.preventDefault();
    this.element.remove();
  }
}
